import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

const SUPPORTED_LANGUAGES = ["en", "de", "vi"];

export function useInitialLanguage() {
  const [searchParams] = useSearchParams();
  const { i18n } = useTranslation();

  useEffect(() => {
    const initialLanguage =
      searchParams.get("initialLanguage") || searchParams.get("initialLanguague");

    if (initialLanguage && SUPPORTED_LANGUAGES.includes(initialLanguage)) {
      // Only change language if it's different from current
      if (i18n.language !== initialLanguage) {
        i18n.changeLanguage(initialLanguage);
      }
    }
  }, [searchParams, i18n]);
}
